import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchTeamPageDataFromApi, useTeamPageDataFromApi } from './pageData';

export type TeamPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useTeamPageDataFromApi>[0]>;
}>;

export type TeamPageCombinedState = ReturnType<typeof useTeamPageDataFromApi>;

export function usePageContext(prefetchedData?: TeamPagePrefetchedContext): TeamPageCombinedState {
	return useTeamPageDataFromApi(prefetchedData?.pageData);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<TeamPagePrefetchedContext> {
	return { pageData: await prefetchTeamPageDataFromApi(context) };
}

export type TeamPagePrefetchedDataProps = PrefetchedDataProps<TeamPagePrefetchedContext>;
